import { weights_intervals, OIML_CLASSES} from "./common"
import { uoms_conversion } from "./commonUtils"
import Big from "big.js"

export const isNumber = (value) => {
    if (typeof value !== 'number') {
        return false
    }
    if (value !== Number(value)) {
        return false
    }

    if (Number.isFinite(value) === false) {
        return false
    }

    return true
}

export const calculate_P = (reading, div, addLoad) => {
    if(div == undefined || div == null){
        return 0
    }
    let a = new Big(div)
    let mindiv = a.times(0.5)
    return Big(reading).plus(mindiv).minus(addLoad)
}

export const MPE = (m_class, divs, total_divs, mass, intervals = [1, 2, 3]) => {
    var curr_div = null;
    for (let single_div of divs) {
        let bonus = Big(single_div).times(9)
        let currRange = Big(single_div).times(total_divs).plus(bonus)
        if (currRange.gte(mass)) {
            curr_div = Big(single_div)
            break
        }
    }
    if (curr_div) {
        let ranges = OIML_CLASSES.ranges
        let actual_ranges = []
        ranges.forEach(element => {
            let v = curr_div.times(element).times(Big(10).pow(4 - m_class))
            actual_ranges.push(v.toString())
        });
        let actual_val = Big(mass)
        if (actual_val.lte(actual_ranges[1])) {
            return curr_div.times(intervals[0]).toString()
        } else if (actual_val.lte(actual_ranges[2])) {
            return curr_div.times(intervals[1]).toString()
        } else {
            return curr_div.times(intervals[2]).toString()
        }
    } else {
        return "-1"
    }
}


export const OIML = (divs, total_divs, mass) => {
    var curr_div = null;
    for (let single_div of divs) {
        let currRange = Big(single_div).times(total_divs)
        if (Big(currRange).gte(mass)) {
            curr_div = Big(single_div)
            break;
        }
    }
    
    if (curr_div) {
        let oiml_class = 0
        let total = Big(total_divs)
        if (total.lte(OIML_CLASSES.divs[0])) 
            { oiml_class = 4 } 
        else if (total.lte(OIML_CLASSES.divs[1])) 
            { oiml_class = 3 } 
        else if (total.lte(OIML_CLASSES.divs[2])) 
            { oiml_class = 2 } 
        else 
            { oiml_class = 1 }
        let intervals = OIML_CLASSES.ranges
        let class_intervals = []
        intervals.forEach(element => {
            let v = curr_div.times(element).times(Big(10).pow(4 - oiml_class))
            class_intervals.push(v)
        })
        let bigMass = Big(mass)
        if (bigMass.lt(class_intervals[1])) { return curr_div.toString() } else if (bigMass.lt(class_intervals[2])) { return curr_div.times(2).toString()} else { return curr_div.times(3).toString() }
    }
    return 0
}

export const algo2 = (weights, nominal) => {
    let sol = {
        0: []
    }
    for (const [key, value] of Object.entries(weights)) {
        for (let i = 0; i < value.length; i++) {
            for (const [key1, value1] of Object.entries(sol)) {
                let new_sol = Big(key1).plus(key).toString()
                if (Big(new_sol).gt(nominal)) {
                    continue
                }
                let new_len = value1.length + 1
                if (!(new_sol in sol) || new_len < sol[new_sol].length) {
                    let new_val = _.cloneDeep(value1)
                    new_val.push(value[i])
                    sol[new_sol] = new_val
                }
            }
        }
    }
    console.log("complete solutions", sol)
    if (nominal in sol) {
        return sol[nominal]
    } else {
        return []
    }
}

const build_dict = (weights) => {
    let dizionario = {}
    for(let i = 0; i<weights.length; i++){
        let nominale = weights[i][0]
        let conto = weights[i][1]
        dizionario[nominale] = conto
    }
    return dizionario
}

const check_sol = (sol, weights, weight) => {
    let dw = build_dict(weights)
    let d = {}
    d[weight] = 1
    if(dw[weight] == 0){
        return false
    }
    for (let v of sol){
        d[v] = (d[v] ? d[v] : 0 ) + 1
        if(d[v] > dw[v]){
            return false
        }
    }
    return true
}
export const get_sub_opt = (tot_weight, cur_weights, sol=[]) => {
    if(tot_weight == 0 || cur_weights.length == 0){
        return []
    }
    let up_weights = [...cur_weights.filter(weight => weight[0]<=tot_weight && weight[1]>0)];
    if (up_weights.length == 0) {
        // console.log("UNREACHABLE")
        return [-1]
    }
    // console.log("up_weights", up_weights, "weight removed", up_weights.at(-1)[0], "tot_weight", tot_weight - up_weights.at(-1)[0])
    up_weights.at(-1)[1] -= 1  //tolgo un peso
    let cur_sol = get_sub_opt(tot_weight - up_weights.at(-1)[0], up_weights, sol)
    up_weights.at(-1)[1] += 1
    sol = [...cur_sol, up_weights.at(-1)[0]]
    // console.log(sol)
    return sol
}

function least(x) {
    return x === Math.floor(x)
        ? +x.toString().replace(/.*(?=[1-9]0*$)/, '')
        : +x.toString().replace(/\d(?=.*[1-9]$)/g, '0');

}

function getBaseLog(x, y) {
    return Math.log(y) / Math.log(x);
  }
  

export const get_trunc_opt = (tot_weight, cur_weights) => {
    let l = least(tot_weight)
    let llog = getBaseLog(10, l)
    llog = Math.ceil(llog) // i pesi sono passati tuti interi
    let sol = undefined
    while(sol == undefined && llog >= 0){
        let minWeight = Math.pow(10, llog)
        let reduced_weights = []
        for(let item of cur_weights){
            if(item[0] >= minWeight){
                reduced_weights.push(item)
            }
        }
        llog -= 1
        sol = get_opt(tot_weight, reduced_weights)
    }
    return sol
}

export const get_opt = (tot_weight, cur_weights, cache = {}, first = 0) => {
    if(tot_weight == 0){
        return []
    }
    if(first > cur_weights.length){
        return undefined;
    }

    if(!(tot_weight in cache)){
        // let tot = 0

        let best_current = undefined
        for(let i = first; i<cur_weights.length; i++){
            let weight = cur_weights[i][0]
            let count = cur_weights[i][1]

            if (!count || weight > tot_weight){
                continue
            }

            cur_weights[i][1] -= 1  //tolgo un peso
            let cur_sol = get_opt(tot_weight - weight, cur_weights, cache, cur_weights[i][1] ? first : first + 1)
            cur_weights[i][1] += 1  //lo riaggiungo

            if(!cur_sol){
                continue
            }
            
            if(!best_current || cur_sol.length < (best_current.length - 1)){
                if (check_sol(cur_sol, cur_weights, weight)){
                    best_current = [...cur_sol, weight]
                }
            }
        }
        cache[tot_weight] = best_current
    }
    return cache[tot_weight]
}


function solutions_timed(nom, weights){
    let t1 = Date.now()
    let sol = get_trunc_opt(nom, weights)
    let t2 = Date.now()
    let t3 = Date.now()
    let sol1 = get_sub_opt(nom, weights)
    let t4 = Date.now()
    console.log("$$ solution 1", (t2-t1), sol)
    console.log("$$ solution 2", (t4-t3), sol1)
}

export const count_size = (sol) => {
    let dizionario = {}
    for(let k of sol){
        dizionario[k] = (dizionario[k] ? dizionario[k] : 0) + 1
    }
    return dizionario
}

export const checkWeight = (primaries) => {
    for (let elem of primaries) {
        if (elem.family === "zavorra") {
            return elem
        }
    }
    return null
}

export const awi_readings_X = (mass, uom) => {
    mass = Big(mass)
    if (uom === "g") {
        mass = mass.times(0.001)
    } else if (uom === "mg") {
        mass = mass.times(0.000001)
    }
    if (mass.lte(1)) {
        return 60
    } else if (mass.lte(10)) {
        return 30
    } else if (mass.lte(20)) {
        return 20
    } else if (mass.gt(20)) {
        return 10
    } else {
        return -1
    }
}

export const awi_dev_std_max = (mass, uom, intervals) => {
    mass = Big(mass)
    if (uom === "kg") {
        mass = mass.times(1000)
    } else if (uom === "mg") {
        mass = mass.times(0.001)
    }
    if (mass.lte(50)) {
        return mass.times(intervals[0]).toString()
    } else if (mass.lte(100)) {
        return intervals[1].toString()
    } else if (mass.lte(200)) {
        return mass.times(intervals[2]).toString()
    } else if (mass.lte(300)) {
        return intervals[3].toString()
    } else if (mass.lte(500)) {
        return mass.times(intervals[4]).toString()
    } else if (mass.lte(1000)) {
        return intervals[5].toString()
    } else if (mass.lte(10000)) {
        return mass.times(intervals[6]).toString()
    } else if (mass.lte(15000)) {
        return intervals[7].toString()
    } else if (mass.gt(15000)) {
        return mass.times(intervals[8]).toString()
    }
}



export const handleInterpolation = (value, data) => {
    // data is the primary values
    let item = {
        nom: value,
        uncertain: 0,
        error: 0
    }
    console.log("$$ DEBUG inside function values", value, data)
    if (data) {
        item.error = Big(data.a).plus( Big(data.b).times(value)).plus(Big(data.c).times(Big(value).pow(2))).plus(Big(data.d).times(Big(value).pow(3))).toString()
        item.uncertain = Big(data.a_U).plus(Big(data.b_U).times(value)).toString()
    }
    return item
}


export const calculateUncertainty = (value, data, resolution, k) => {
    let uncertainty = 0
    if (data && value && resolution && k) {
        console.log("$$ dati incertezza", data, value, resolution, k)
        let u2 = Big(value).pow(2).plus(Big(data.uniformity).pow(2)).plus(Big(data.drift).pow(2)).plus(Big(resolution).pow(2))
        uncertainty = u2.sqrt().times(k).toString()
    }
    return uncertainty
}


export const filterPrimaries = (platform, primaries, report_type) => {
    switch (platform.i_data.family) {
        case "bilancia nawi":
            return filterBilance(platform, primaries, report_type);
        case "bilancia nawi meccanica":
            return filterBilance(platform, primaries, report_type);
        default:
            return primaries
    }
}

const filterBilance = (platform, primaries, report_type) => {
    let stats = platform.i_data.ranges.reduce((a, b) => {
        a.max = (b.max > a.max) ? b.max : a.max
        a.d = (b.d < a.d) ? b.d : a.d
        return a
    }, { max: 0, d: Number.POSITIVE_INFINITY })
    switch (report_type) {
        // 1case "leg":
        // case "iso_simple":
        case "iso":
            {
                let conv_factor = uoms_conversion[platform.i_data.uom]["g"]
                let conv_d = Big(conv_factor).times(stats.d).toString()
                let minClass = calculateMinClass(conv_d)
                let temp = primaries.filter((item) => {
                    if (item.family != "pesiera"){
                        return false
                    }
                    let temp = item.primary_data.data
                    let conv_F = uoms_conversion[temp.uom][platform.i_data.uom]
                    if(temp.min_weight == Number.POSITIVE_INFINITY || temp.min_u == Number.POSITIVE_INFINITY || temp.min_weight == null || temp.min_u == null){
                        return false
                    }
                    let result = Big(temp.w_class).lte(minClass) && Big(temp.min_weight).times(conv_F).lte(stats.max) && Big(temp.min_u).times(Big(conv_F).times(0.001)).lte(Big(stats.d).times(0.3))
                    return result
                })
                return temp
            }
        default:
            return primaries
    }
}

// const isWeightEnabled = (max, uom) => {
//     let maxB = Big(max)
//     if (uom === "mg") {
//         return false
//     }
//     if (uom === "g") {
//         maxB = maxB.times(0.001)
//     }
//     return maxB.gte(1000)
// }

const calculateMinClass = (conv_d) => {
    if (Big(conv_d).lte( weights_intervals[0])) {
        return 2
    } else if (Big(conv_d).lte(weights_intervals[1])) {
        return 3
    } else {
        return 5
    }
}